export const SESSION_STORAGE_EVENTS_KEY = 'googleMeetAppTrackerEvents';
export const SCREENS = {
  comments: 'Comments-Tab',
  playbooks: 'Playbooks-Tab',
  associations: 'Associations-Tab',
  participants: 'Participants-Tab',
  login: 'Welcome-Page',
  accounts: 'Accounts-Page',
  associatedContact: 'Associated-Contact-Detail-Page',
  associatedDeal: 'Associated-Deal-Detail-Page',
  associatedTicket: 'Associated-Ticket-Detail-Page',
  associatedCompany: 'Associated-Company-Detail-Page',
  associatedMeeting: 'Associated-Meeting-Detail-Page',
  associateContact: 'Associate-Contact-Page',
  associateDeal: 'Associate-Deal-Page',
  associateTicket: 'Associate-Ticket-Page',
  associateCompany: 'Associate-Company-Page',
  associateMeeting: 'Associate-Meeting-Page',
  associatePannelAssociateTab: 'Associate-Pannel-Associate-Tab',
  associatePannelCreateTab: 'Associate-Pannel-Create-Tab'
};
export const USAGE_EVENTS_NAMES = {
  addOrUpdateComment: 'Add or Update Comment',
  mapContact: 'Map Contact',
  unmapContact: 'Unmap Contact',
  associate: 'Associate Call to CRM Object',
  dissociate: 'Dissociate CRM Object',
  editObject: 'Edit CRM Object',
  createCrmObject: 'Create CRM Object',
  openPlaybook: 'Open Playbook',
  createDraftCallObject: 'Create Draft Call Object',
  autoMap: 'Auto map participants to contacts'
};
export const ACTIONS = {
  participants: {
    clickMap: {
      action: 'click-map-contact-button',
      description: 'Click "map" contact button'
    },
    clickUnmap: {
      action: 'click-unmap-contact-button',
      description: 'Click "unmap" contact button'
    },
    clickTab: {
      action: 'click-participants-tab',
      description: 'Click Participants Tab'
    },
    clickSendNotification: {
      action: 'click-send-notification',
      description: 'Click send notification button to get co-host permission'
    },
    clickReadNotification: {
      action: 'click-read-notification',
      description: 'Click read notification button to mark as read'
    },
    clickAssociate: {
      action: 'click-associate-contact-button',
      description: 'Click "associate" contact button'
    },
    clickCreate: {
      action: 'click-create-contact-button',
      description: 'Click "create" contact button'
    },
    clickDissociate: {
      action: 'click-dissociate-contact-button',
      description: 'Click "dissociate" contact button'
    },
    clickDissociateCancel: {
      action: 'click-cancel-dissociate-contact-button',
      description: 'Click "cancel-dissociate" contact button'
    },
    clickDissociateConfirm: {
      action: 'click-confirm-dissociate-contact-button',
      description: 'Click "confirm-dissociate" contact button'
    },
    autoMap: {
      name: USAGE_EVENTS_NAMES.autoMap,
      description: 'Auto map participants to contacts'
    }
  },
  comments: {
    new: {
      action: 'start-new-comment',
      description: 'Start new comment'
    },
    edit: {
      action: 'click-edit-comment',
      description: 'Edit comment'
    },
    delete: {
      action: 'click-delete-comment',
      description: 'Delete comment'
    },
    clickTab: {
      action: 'click-comment-tab',
      description: 'Click Comments Tab'
    },
    save: {
      name: USAGE_EVENTS_NAMES.addOrUpdateComment,
      description: 'Save comment'
    }
  },
  playbooks: {
    clickTab: {
      action: 'click-playbooks-tab',
      description: 'Click Playbooks Tab'
    },
    openPlaybook: {
      name: USAGE_EVENTS_NAMES.openPlaybook,
      description: 'Open playbook item'
    },
    clickPlaybook: {
      action: 'click-playbook',
      description: 'Click on playbook item'
    }
  },
  accounts: {
    connect: {
      action: 'connect-account',
      description: 'Log in to HubSpot account'
    }
  },
  login: {
    start: {
      action: 'click-start-button',
      description: 'Click start button on home page'
    }
  },
  associations: {
    clickTab: {
      action: 'click-associations-tab',
      description: 'Click Associations Tab'
    },
    clickOpen: {
      action: 'open-in-hubspot',
      description: 'Click Open in HubSpot'
    },
    clickAdd: {
      action: 'click-add-call-association-link',
      description: 'Click "+ Add" on associations tab for object'
    },
    associated: {
      name: USAGE_EVENTS_NAMES.associate,
      description: 'Clicked Add on Associations Page and associated call to company, deal, ticket'
    },
    dissociated: {
      name: USAGE_EVENTS_NAMES.dissociate,
      description: 'Click remove on Associations Page and dissociate CRM object from call object'
    }
  },
  associatedContact: {
    clickOpen: {
      action: 'open-in-hubspot',
      description: 'Click Open in HubSpot'
    }
  },
  associateContact: {
    map: {
      name: USAGE_EVENTS_NAMES.mapContact,
      description: 'Clicked and successfully completed mapping participant to contact'
    },
    unmap: {
      name: USAGE_EVENTS_NAMES.unmapContact,
      description: 'Successfully unmap contact from participant'
    }
  },
  general: {
    clickPreview: {
      action: 'open-detailed-object-view',
      description: 'Open detailed object information, to see properties and values'
    },
    closePreview: {
      action: 'close-detailed-object-view',
      description: 'Close detailed object view'
    },
    clickStartEdit: {
      action: 'start-edit-object',
      description: 'Click edit crm object'
    },
    clickCancelEdit: {
      action: 'cancel-edit-object',
      description: 'Click cancel edit crm object'
    },
    editObject: {
      name: USAGE_EVENTS_NAMES.editObject,
      description: 'Click and save changes during edit crm object'
    },
    closeAssociationPanel: {
      action: 'close-association-panel',
      description: 'Close association pannel'
    },
    switchAssociationPanelTab: {
      action: 'switch-association-panel-tab',
      description: 'Click on tab in associate pannel'
    },
    createCrmObject: {
      name: USAGE_EVENTS_NAMES.createCrmObject,
      description: 'Successfully created new CRM object'
    }
  }
};